import { LiffProvider } from "context/Liff";
import AppWrapper from "AppWrapper";

const LIFFID = `${process.env.REACT_APP_LIFFID}`;
console.log("2026-03-30 23:00");
// console.log(process.env.REACT_APP_API_URL);
console.log(process.env.REACT_APP_ENV);
//  阻擋console.log
console.log = function () {};

function App() {
  return (
    <LiffProvider liffId={LIFFID}>
      <AppWrapper />
    </LiffProvider>
  );
}

export default App;
